var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.artists)?_c('BaseSection',{attrs:{"padded":""}},[_c(_setup.ArtistBlock,{attrs:{"artists":_setup.artists}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }